export class EndoMultiToothExamSurfaceAutofillDetailConfigurationModel {
  SurfaceAutofillDetailID: string;
  SurfaceAutofillID: string;
  ToothSurfaceId: string;
  enumProbingDepthID: string;
}
